import { deriveMaterial } from 'Pods/ThreeDStudio/Shared/Utils/deriveMaterial'
import { getAssetByTypeAndSource } from 'Pods/ThreeDStudio/Shared/Utils/getAssetByTypeAndSource'
import { getInputImageAsset } from 'Pods/ThreeDStudio/Shared/Utils/getInputImageAsset'
import {
  ACTION,
  PROVIDER,
  DEFAULT_TEXTURE_SETTINGS,
  VIEWER_SIDEBAR_TAB,
  TEXTURE_ACTION_TAB,
} from 'Pods/ThreeDStudio/Store/constants'

import { getModelFormatOutput } from './getModelFormatOutput'

/**
 * Builds the ThreeDStudio store patch for a Tencent retexture-pro run.
 * Picks the active texture action tab from prompt presence (TEXT when prompt
 * exists, otherwise IMAGE) and falls back to DEFAULT_TEXTURE_SETTINGS for any
 * missing input. Opens the viewer sidebar on the TEXTURE tab.
 *
 * @param {Object} openedModel - Run object from the library
 * @returns {Object} parsedData - ThreeDStudio store patch
 */
export const parseTencentRetextureProData = (openedModel) => {
  const {
    prompt,
    enablePbr,
    geometryOnly,
    modelFormatOutput: rawModelFormatOutput,
    inputAssets,
    outputAssets,
    generatorSessionId,
    id: sessionId,
  } = openedModel
  const enhancedProvider = PROVIDER.TENCENT
  const enhancedAction = ACTION.RETEXTURE
  const activeTextureActionTab = prompt ? TEXTURE_ACTION_TAB.TEXT : TEXTURE_ACTION_TAB.IMAGE
  const material = deriveMaterial(enablePbr, geometryOnly)

  const {
    assetId: inputThreeD,
    fileUrl: inputThreeDUrl,
  } = getAssetByTypeAndSource(outputAssets, '3d_model', 'ai_generated')
  const modelFormatOutput = getModelFormatOutput({
    modelFormatOutput: rawModelFormatOutput,
    modelUrl: inputThreeDUrl,
  })
  const {
    assetId: inputImage,
    fileUrl: inputImageUrl,
  } = getInputImageAsset(inputAssets)

  const schema = { enhancedAction, enhancedProvider }
  const generation = { sessionId, generatorSessionId }
  const viewer = { fileFormat: modelFormatOutput, inputThreeD, material }
  const textureSettings = {
    inputImage: inputImage ?? DEFAULT_TEXTURE_SETTINGS.inputImage,
    inputImageUrl: inputImageUrl ?? DEFAULT_TEXTURE_SETTINGS.inputImageUrl,
    prompt: prompt ?? DEFAULT_TEXTURE_SETTINGS.prompt,
    material: material ?? DEFAULT_TEXTURE_SETTINGS.material,
    enablePbr: enablePbr ?? DEFAULT_TEXTURE_SETTINGS.enablePbr,
  }

  const ui = {
    isModelSettingsOpen: false,
    isViewerSidebarOpen: true,
    activeViewerSidebarTab: VIEWER_SIDEBAR_TAB.TEXTURE,
    activeTextureActionTab,
  }

  return {
    openedModel,
    schema,
    textureSettings,
    ui,
    generation,
    viewer,
  }
}
